import {MonitorReducer, ReducerFromState} from "../../../@types/reducers";

export const isInitialized = (state: ReducerFromState<MonitorReducer>): boolean => state.monitor.initializing;